/**
 * Guest access panel that does not show the nav menu
 */
class GuestAccess extends CollectionPanel {

	constructor(title: string, id?: number | string, sort?: string) {
		super(title)

		this.isCollectionView = false;
		this.sort = sort;

		this.view();
		this.setUpEvents();
		this.getData(id);
	}

}